import { styled } from "@introist/react-foundation/v2";
import { ComponentProps } from "react";
import styles from "./Link.module.scss";

export const Link = ({ target = "_blank", rel = "noopener", ...props }: ComponentProps<"a">) => {
  return styled("a", { target, rel, ...props }, styles.Link);
};
